export class Sprite {
  image: string;
  height: number;
  width: number;
}

export class Sprites {
  // PROCESS COMPONENTS
  static BOILER = { image: '/assets/flow-icons/components/boiler.png', height: 85, width: 85 };
  static CHP = { image: '/assets/flow-icons/components/CHP.png', height: 120, width: 120 };
  static DEWATERER = { image: '/assets/flow-icons/components/dewaterer.png', height: 90, width: 90 };
  static GENERATOR = { image: '/assets/flow-icons/components/generator.png', height: 100, width: 100 };
  static MIXER = { image: '/assets/flow-icons/components/mixer.png', height: 90, width: 90 };
  static UPGRADER = { image: '/assets/flow-icons/components/upgrader.png', height: 100, width: 100 };

  // DIGESTERS
  static WET_CONTINUOUS_DIGESTER = { image: '/assets/flow-icons/components/wetcontinuousdigester.png', height: 130, width: 130 };
  static LAGOON_DIGESTER = { image: '/assets/flow-icons/components/lagoondigester.png', height: 114, width: 340 };
  static DRY_CONTINUOUS_DIGESTER = { image: '/assets/flow-icons/components/drycontinuousdigester.png', height: 118, width: 455 };
  static DRY_BATCH_DIGESTER = { image: '/assets/flow-icons/components/drybatchdigester.png', height: 160, width: 160 };

  // STORAGE
  static FEEDSTOCK_STORAGE_LIQUID = { image: '/assets/flow-icons/components/feedstockstorageliquid.png', height: 90, width: 90 };
  static FEEDSTOCK_STORAGE_SOLID = { image: '/assets/flow-icons/components/feedstockstoragesolid.png', height: 90, width: 90 };
  static DIGESTATE_STORAGE_LIQUID = { image: '/assets/flow-icons/components/digestatestorage.png', height: 100, width: 100 };
  static DIGESTATE_STORAGE_SOLID = { image: '/assets/flow-icons/components/biogasscrubber.png', height: 90, width: 90 };
  static BIOMETHANE_STORAGE = { image: '/assets/flow-icons/components/biogasstoragesphere.png', height: 90, width: 90 };

  // FLOW
  static BIOGAS_FLOW = { image: '/assets/flow-icons/flows/biogas.png', height: 50, width: 50 };
  static INFLUENT_FLOW = { image: '/assets/flow-icons/flows/influent.png', height: 50, width: 50 };
  static RECYCLE_STREAM_FLOW = { image: '/assets/flow-icons/flows/recyclestream.png', height: 50, width: 50 };
  static WHOLE_DIGESTATE_FLOW = { image: '/assets/flow-icons/flows/wholedigestate.png', height: 50, width: 50 };

  // FEEDSTOCK
  static AGRIWASTE = { image: '/assets/flow-icons/inputs/agriwaste.png', height: 50, width: 50 };
  static ANIMAL_PRODUCT = { image: '/assets/flow-icons/inputs/animalproduct.png', height: 50, width: 50 };
  static ENERGY_CROPS = { image: '/assets/flow-icons/inputs/energycrops.png', height: 50, width: 50 };
  static FRESH_WATER = { image: '/assets/flow-icons/inputs/freshwater.png', height: 50, width: 50 };
  static INDUSTRIAL_WASTE = { image: '/assets/flow-icons/inputs/industrialwaste.png', height: 50, width: 50 };
  static INFLUENT = { image: '/assets/flow-icons/inputs/influent.png', height: 50, width: 50 };
  static MUNICIPAL_BIOWASTE = { image: '/assets/flow-icons/inputs/municipalbiowaste.png', height: 50, width: 50 };
  static MUNICIPAL_SEWAGE_SLUDGE = { image: '/assets/flow-icons/inputs/municipalsewagesludge.png', height: 50, width: 50 };

  // PRODUCTS
  static BIOGAS = { image: '/assets/flow-icons/outputs/biogas.png', height: 50, width: 50 };
  static FERTILIZER = { image: '/assets/flow-icons/outputs/fertilizer.png', height: 50, width: 50 };
  static FLARE = { image: '/assets/flow-icons/outputs/flare.png', height: 50, width: 50 };
  static HEAT = { image: '/assets/flow-icons/outputs/heat.png', height: 50, width: 50 };
  static LIQUID_FERTILIZER = { image: '/assets/flow-icons/outputs/liquidfertilizer.png', height: 50, width: 50 };
  static POWER = { image: '/assets/flow-icons/outputs/power.png', height: 50, width: 50 };
  static RECYCLE_STREAM = { image: '/assets/flow-icons/outputs/recyclestream.png', height: 50, width: 50 };
  static RNG = { image: '/assets/flow-icons/outputs/RNG.png', height: 50, width: 50 };
  static STEAM = { image: '/assets/flow-icons/outputs/steam.png', height: 50, width: 50 };
  static WATER = { image: '/assets/flow-icons/outputs/water.png', height: 50, width: 50 };

  // HELPER
  static EMPTY = { image: '/assets/flow-icons/empty.png', height: 20, width: 20 };
}
